export const siteInfo = {
  name: '樱花漫画',
  tagline: '好看的漫画推荐',
  slogan: '追更漫画全集免费在线看，轻松收藏你爱的每一部',
  h1: '樱花漫画 - 免费漫画全集下拉式阅读平台',
  intro1: '樱花漫画致力于为漫迷打造一站式的免费漫画阅读体验。我们收录海量漫画资源，涵盖热血、恋爱、奇幻、悬疑、搞笑、都市、古风等全品类题材，所有漫画支持全集下拉式阅读，无需翻页点击，一滑到底畅享沉浸式阅读。',
  intro2: '平台每日更新热门连载漫画最新章节，同时精心整理经典完结作品全集，无论你是追更党还是补番族，都能在这里找到属于自己的漫画天地。更有编辑精选推荐、读者真实评价和实时热度榜单，帮你快速发现高质量好漫画。',
  stats: [
    { value: '每日更新', label: '章节更新节奏' },
    { value: '全品类覆盖', label: '题材类型' },
    { value: '无广告阅读', label: '阅读体验' },
  ],
  ctaPrimary: { label: '开始阅读', href: '#index' },
  ctaSecondary: { label: '下载APP', href: '#app' },
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '专题合集', href: '#index' },
  { label: '焦点推荐', href: '#carousel' },
  { label: 'APP下载', href: '#app' },
  { label: '关于我们', href: '#about' },
  { label: '读者心声', href: '#comments' },
];

export const topicCollections = [
  {
    title: '热血冒险',
    icon: 'ri-fire-line',
    desc: '燃烧吧少年！最燃最热血的冒险故事，主角逆袭、战斗升级，每一页都让你肾上腺素飙升。',
    color: 'accent',
  },
  {
    title: '恋爱甜宠',
    icon: 'ri-heart-line',
    desc: '心动的瞬间、甜蜜的日常，从校园到职场，最让人心动的恋爱漫画都在这里等你。',
    color: 'primary',
  },
  {
    title: '悬疑推理',
    icon: 'ri-search-eye-line',
    desc: '烧脑剧情层层反转，每一个细节都暗藏玄机。跟随主角一起揭开谜底，体验智斗快感。',
    color: 'secondary',
  },
  {
    title: '奇幻异世界',
    icon: 'ri-magic-line',
    desc: '穿越、转生、异世界冒险，想象力无边界。在魔法与剑的世界里开启属于你的奇幻旅程。',
    color: 'accent',
  },
  {
    title: '都市职场',
    icon: 'ri-building-line',
    desc: '现代都市里的奋斗与成长，职场博弈、人情冷暖，这里有最贴近生活的精彩故事。',
    color: 'secondary',
  },
  {
    title: '搞笑日常',
    icon: 'ri-emotion-laugh-line',
    desc: '轻松解压的快乐源泉，沙雕剧情、反差萌角色，让你在忙碌生活中找到片刻欢笑。',
    color: 'primary',
  },
  {
    title: '经典怀旧',
    icon: 'ri-history-line',
    desc: '那些年我们一起追过的经典漫画，重温青春记忆。每一部都是时代的印记与不朽的传奇。',
    color: 'accent',
  },
];

export const mediaCards = [
  {
    title: '新番速递：本季最值得追的5部漫画',
    desc: '编辑团队精选本季新连载中最值得期待的5部作品，从画风到剧情全方位解析，帮你锁定追更目标。',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20anime%20style%20illustration%20of%20a%20manga%20reader%20holding%20a%20tablet%20with%20colorful%20manga%20pages%20floating%20around%2C%20cherry%20blossom%20petals%20in%20the%20air%2C%20warm%20pink%20and%20cream%20tones%2C%20soft%20lighting%2C%20clean%20composition%2C%20joyful%20atmosphere%2C%20modern%20digital%20art%20style&width=640&height=360&seq=media-card-01&orientation=landscape',
    tag: '新番推荐',
  },
  {
    title: '编辑精选：冷门佳作发掘',
    desc: '那些不为人知却质量上乘的冷门漫画，每一部都值得被更多人看到。编辑团队深入挖掘，为你带来隐藏的宝藏。',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20nook%20with%20a%20stack%20of%20beautifully%20illustrated%20manga%20books%2C%20a%20warm%20lamp%20glowing%20softly%2C%20cherry%20blossom%20branch%20in%20a%20vase%2C%20cream%20and%20pastel%20pink%20color%20palette%2C%20gentle%20atmosphere%2C%20artistic%20photography%20style%2C%20minimal%20and%20elegant%20composition&width=640&height=360&seq=media-card-02&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '漫画家访谈：创作背后的故事',
    desc: '走进漫画家的创作世界，了解那些精彩故事背后的灵感来源、创作心路与不为人知的坚持与热爱。',
    cover: 'https://readdy.ai/api/search-image?query=A%20creative%20artist%20studio%20with%20drawing%20tablet%20and%20manga%20sketches%20pinned%20on%20the%20wall%2C%20warm%20natural%20light%20streaming%20through%20window%2C%20cherry%20blossom%20view%20outside%2C%20soft%20pink%20and%20cream%20tones%2C%20inspiring%20and%20peaceful%20atmosphere%2C%20clean%20illustration%20style&width=640&height=360&seq=media-card-03&orientation=landscape',
    tag: '创作者访谈',
  },
  {
    title: '下拉式阅读的正确打开方式',
    desc: '告别传统翻页，体验流畅的下拉式阅读。我们为你准备了最舒适的阅读姿势指南与个性化设置技巧。',
    cover: 'https://readdy.ai/api/search-image?query=A%20person%20comfortably%20reading%20manga%20on%20a%20smartphone%20with%20smooth%20scrolling%20manga%20pages%20displayed%2C%20cozy%20cafe%20setting%2C%20warm%20ambient%20lighting%2C%20cherry%20blossom%20decorations%2C%20soft%20cream%20and%20pink%20tones%2C%20relaxed%20modern%20lifestyle%20photography&width=640&height=360&seq=media-card-04&orientation=landscape',
    tag: '阅读指南',
  },
  {
    title: '漫评解说：深度解析热门作品',
    desc: '从分镜、叙事、人物塑造等多个维度深度解析当前最热漫画，带你看懂每一格的精妙之处。',
    cover: 'https://readdy.ai/api/search-image?query=A%20closeup%20of%20beautiful%20manga%20pages%20spread%20open%20on%20a%20wooden%20desk%2C%20magnifying%20glass%20highlighting%20intricate%20artwork%20details%2C%20warm%20natural%20lighting%2C%20cherry%20blossom%20petals%20scattered%20artfully%2C%20cream%20and%20soft%20pink%20aesthetic%2C%20elegant%20scholarly%20vibe&width=640&height=360&seq=media-card-05&orientation=landscape',
    tag: '深度漫评',
  },
];

export const infoCards = [
  {
    title: '星海征途',
    author: '林间月',
    category: '科幻冒险',
    desc: '公元2147年，人类踏足星辰大海。少年林辰意外获得远古星图，踏上横跨银河的史诗征途，在未知星域中揭开宇宙最深处的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20cover%20illustration%20of%20a%20young%20hero%20in%20futuristic%20space%20suit%20standing%20before%20a%20vast%20starry%20galaxy%2C%20determined%20expression%2C%20glowing%20stars%20and%20nebula%20in%20background%2C%20warm%20golden%20and%20deep%20blue%20color%20scheme%2C%20clean%20anime%20art%20style%2C%20epic%20atmosphere&width=400&height=560&seq=info-card-01&orientation=portrait',
    status: '连载中',
    chapters: 247,
  },
  {
    title: '长安幻夜',
    author: '墨白',
    category: '古风奇幻',
    desc: '大唐盛世之下，妖魔暗涌。少女苏晚意外觉醒灵视之力，在繁华长安的夜色中与神秘少年相遇，共同守护人间与妖界的平衡。',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20manga%20style%20cover%20of%20a%20beautiful%20girl%20in%20traditional%20Tang%20dynasty%20hanfu%20dress%2C%20holding%20a%20glowing%20lantern%2C%20ancient%20Chinese%20palace%20and%20cherry%20blossoms%20in%20background%2C%20mystical%20atmosphere%2C%20warm%20golden%20and%20crimson%20tones%2C%20elegant%20art%20style&width=400&height=560&seq=info-card-02&orientation=portrait',
    status: '连载中',
    chapters: 189,
  },
  {
    title: '逆天战神',
    author: '铁骑',
    category: '热血战斗',
    desc: '废柴少年偶得战神传承，从此逆天改命！拳破苍穹、脚踏九州，以无敌之姿横扫六合八荒，书写属于他的不败传奇。',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20manga%20cover%20illustration%20of%20a%20fierce%20martial%20artist%20with%20flaming%20fists%2C%20dynamic%20action%20pose%2C%20energy%20exploding%20around%20him%2C%20mountainous%20landscape%20background%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20intense%20shonen%20style%20art%2C%20epic%20and%20dramatic&width=400&height=560&seq=info-card-03&orientation=portrait',
    status: '连载中',
    chapters: 312,
  },
  {
    title: '甜蜜契约',
    author: '苏小糖',
    category: '恋爱甜宠',
    desc: '一场意外让高冷总裁与元气少女签订了"恋爱契约"。从互相嫌弃到暗生情愫，甜度超标的契约恋爱正在上演。',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20manga%20cover%20with%20a%20handsome%20young%20man%20and%20cute%20girl%20standing%20back%20to%20back%20under%20cherry%20blossom%20trees%2C%20blushing%20expressions%2C%20soft%20pink%20petals%20falling%2C%20warm%20pastel%20color%20palette%2C%20gentle%20spring%20atmosphere%2C%20shojo%20manga%20art%20style&width=400&height=560&seq=info-card-04&orientation=portrait',
    status: '已完结',
    chapters: 156,
  },
  {
    title: '末日生存指南',
    author: '夜行者',
    category: '悬疑生存',
    desc: '当末日降临，文明崩塌，普通人如何在废墟中求生？这不是英雄的故事，而是每一个挣扎求生的灵魂最真实的写照。',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20atmospheric%20manga%20cover%20showing%20a%20survivor%20in%20a%20post%20apocalyptic%20cityscape%2C%20wearing%20a%20tattered%20coat%2C%20holding%20a%20crowbar%2C%20ruined%20buildings%20and%20overcast%20sky%20behind%2C%20moody%20lighting%2C%20muted%20warm%20earth%20tones%2C%20suspenseful%20seinen%20style%20art&width=400&height=560&seq=info-card-05&orientation=portrait',
    status: '连载中',
    chapters: 98,
  },
];

export const appEntry = {
  title: '樱花漫画 APP',
  subtitle: '随时随地，畅享下拉式阅读',
  desc: '下载樱花漫画 APP，享受更流畅的阅读体验。离线下载、夜间模式、阅读进度云同步，让好漫画永远陪伴你左右。支持 iOS 与 Android 双平台。',
  features: [
    { icon: 'ri-download-2-line', text: '离线下载，无网络也能看' },
    { icon: 'ri-moon-line', text: '夜间模式，护眼舒适阅读' },
    { icon: 'ri-cloud-line', text: '云同步，多设备无缝切换' },
    { icon: 'ri-notification-3-line', text: '更新提醒，追更快人一步' },
  ],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20beautiful%20manga%20artwork%20on%20screen%2C%20floating%20cherry%20blossom%20petals%20around%20the%20phone%2C%20clean%20minimal%20background%2C%20soft%20pink%20and%20cream%20gradient%2C%20elegant%20product%20photography%20style%2C%20warm%20lighting&width=600&height=800&seq=app-entry-01&orientation=portrait',
};

export const carouselItems = [
  {
    title: '热血巅峰对决：年度最强战斗场面大盘点',
    category: '盘点特辑',
    desc: '从拳拳到肉的近身搏杀到毁天灭地的神级对决，我们精选了本年度最令人热血沸腾的漫画战斗名场面，每一格都值得反复品味。',
    image: 'https://readdy.ai/api/search-image?query=An%20epic%20manga%20style%20battle%20scene%20with%20two%20powerful%20warriors%20clashing%2C%20energy%20explosions%20and%20dynamic%20speed%20lines%2C%20dramatic%20perspective%20from%20below%2C%20cherry%20blossom%20petals%20contrasting%20with%20intense%20action%2C%20warm%20crimson%20and%20gold%20color%20palette%2C%20high%20impact%20shonen%20style&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '热血',
  },
  {
    title: '甜到齁！让人姨母笑的恋爱漫画名场面',
    category: '甜宠合集',
    desc: '那些让你捂脸尖叫、心跳加速的恋爱名场面，从初遇到告白，从牵手到拥抱，每一幕都甜度超标，让人忍不住反复回看。',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20style%20scene%20of%20a%20couple%20holding%20hands%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20sunlight%20filtering%20through%20petals%2C%20gentle%20expressions%2C%20warm%20pink%20and%20cream%20tones%2C%20dreamy%20shojo%20style%20illustration%2C%20tender%20and%20heartwarming%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '恋爱',
  },
  {
    title: '脑洞大开！奇幻异世界漫画入坑指南',
    category: '入坑推荐',
    desc: '从穿越转生到系统流，从剑与魔法到科技修仙，奇幻异世界题材百花齐放。我们为你整理了入门必看的经典与最新力作。',
    image: 'https://readdy.ai/api/search-image?query=A%20fantastical%20manga%20style%20illustration%20of%20a%20portal%20opening%20to%20a%20magical%20world%20with%20floating%20islands%20and%20castles%2C%20a%20young%20adventurer%20stepping%20through%2C%20dragons%20flying%20in%20distance%2C%20warm%20golden%20and%20purple%20tones%2C%20whimsical%20and%20grand%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '奇幻',
  },
  {
    title: '烧脑悬疑：反转再反转的神作漫画推荐',
    category: '悬疑精选',
    desc: '最精彩的悬疑漫画往往让你猜不到下一秒会发生什么。这些神作级别的悬疑漫画，每一部都拥有令人拍案叫绝的剧情设计。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20style%20scene%20with%20a%20detective%20figure%20standing%20in%20shadows%2C%20clue%20strings%20connecting%20across%20a%20dark%20room%2C%20dramatic%20lighting%20from%20a%20single%20window%2C%20cherry%20blossom%20petals%20adding%20contrast%2C%20warm%20sepia%20and%20deep%20brown%20tones%2C%20noir%20inspired%20art%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '悬疑',
  },
  {
    title: '经典永流传：影响一代人的漫画大师作品',
    category: '经典回顾',
    desc: '有些漫画不仅仅是作品，更是一个时代的文化符号。让我们一起重温那些定义了漫画艺术高度的大师级经典之作。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20manga%20style%20illustration%20of%20a%20vintage%20bookshelf%20filled%20with%20classic%20manga%20volumes%2C%20warm%20afternoon%20sunlight%20streaming%20in%2C%20cherry%20blossom%20branch%20outside%20window%2C%20dust%20motes%20in%20light%20beams%2C%20warm%20sepia%20and%20cream%20tones%2C%20sentimental%20and%20timeless%20atmosphere&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '经典',
  },
];

export const aboutInfo = {
  title: '关于樱花漫画',
  desc1: '樱花漫画成立于2020年，是国内领先的免费漫画在线阅读平台。我们始终相信，优秀的漫画作品应该被更多人看到、阅读和喜爱。三年来，我们坚持无广告、无付费墙的纯粹阅读体验，为数百万漫迷提供高质量的漫画内容服务。',
  desc2: '我们的编辑团队每日精选优质漫画，从热门连载到冷门佳作，从国漫原创到海外引进，力求让每一位读者都能在这里找到心仪的作品。下拉式阅读、智能推荐、个性化书架的创新设计，让漫画阅读变得更简单、更沉浸。',
  values: [
    { label: '上线时间', value: '2020年' },
    { label: '收录作品', value: '50,000+' },
    { label: '月活读者', value: '300万+' },
    { label: '日更新章节', value: '2,000+' },
  ],
};

export const featureCards = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '告别传统翻页模式，采用流畅的下拉滚动阅读。一滑到底，让阅读节奏不被打断，沉浸感翻倍。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能书架',
    desc: '自动记录阅读进度，跨设备云同步。收藏夹分类管理，追更列表自动排序，你的专属漫画书架。',
  },
  {
    icon: 'ri-sparkling-line',
    title: '每日更新',
    desc: '热门连载每日准时更新，编辑精选推荐帮你发现好漫画。追更提醒不让你错过任何精彩章节。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读',
    desc: '全站无弹窗广告、无强制付费，回归阅读本身的纯粹乐趣。高清画质加载，每一格都清晰可见。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '网页端、手机端、平板全平台覆盖。响应式设计自适应屏幕，无论什么设备都能获得最佳阅读体验。',
  },
];

export const updateItems = [
  { date: '2026-07-28', title: '《星海征途》第247话更新', desc: '林辰终于抵达银河核心，远古星图的终极秘密即将揭晓。', tag: '最新' },
  { date: '2026-07-28', title: '《长安幻夜》第189话更新', desc: '苏晚与神秘少年联手对抗妖王，长安城上空妖气弥漫。', tag: '热门' },
  { date: '2026-07-27', title: '《逆天战神》第312话更新', desc: '战神传承完全觉醒，主角以一敌百震撼全场。', tag: '热门' },
  { date: '2026-07-27', title: '新作上架《深海迷踪》', desc: '深海探险题材全新力作，神秘海底世界等你来探索。', tag: '新作' },
  { date: '2026-07-26', title: '《末日生存指南》第98话更新', desc: '幸存者营地遭遇变异兽潮，生死存亡的关键时刻。', tag: '' },
  { date: '2026-07-26', title: '平台功能升级：夜间模式2.0', desc: '全新护眼算法，自动调节色温，夜间阅读更舒适。', tag: '公告' },
  { date: '2026-07-25', title: '《甜蜜契约》番外篇上线', desc: '完结后的甜蜜番外，主角婚后日常甜度持续超标。', tag: '番外' },
  { date: '2026-07-25', title: '七月编辑精选书单发布', desc: '本月最值得追的10部漫画推荐，品质保障不容错过。', tag: '精选' },
  { date: '2026-07-24', title: '《星海征途》动画化决定', desc: '人气科幻漫画正式宣布动画化，预计明年上线播出。', tag: '重磅' },
];

export const faqItems = [
  {
    q: '樱花漫画是免费的吗？需要注册吗？',
    a: '樱花漫画完全免费，所有漫画均可无限制阅读。浏览漫画无需注册登录，如果你需要跨设备同步阅读进度和收藏漫画，可以免费注册账号享受云同步功能。',
  },
  {
    q: '什么是下拉式阅读？和传统翻页有什么区别？',
    a: '下拉式阅读是将整话漫画内容以纵向排列的方式呈现在一个页面中，你只需要向下滑动即可连续阅读，无需点击"下一页"按钮。这种方式更接近手机端的自然浏览习惯，阅读体验更加流畅沉浸，不会因为加载下一页而打断阅读节奏。',
  },
  {
    q: '漫画更新频率是怎样的？如何知道喜欢的漫画更新了？',
    a: '热门连载漫画通常保持日更或周更的节奏，具体更新频率取决于作者和版权方的安排。你可以将漫画加入书架收藏，更新时书架会有提示标记。下载APP后还可以开启推送通知，第一时间获取更新提醒。',
  },
  {
    q: '支持离线下载吗？下载的漫画在哪里看？',
    a: '离线下载功能在樱花漫画 APP 中可用。你可以将喜欢的漫画章节下载到本地，在没有网络的情况下也能随时阅读。下载的漫画保存在 APP 内的"下载管理"中，不占用系统相册空间。',
  },
  {
    q: '阅读记录会丢失吗？换手机了怎么办？',
    a: '注册账号并登录后，你的阅读进度、书架收藏和阅读偏好都会自动同步到云端。更换手机或设备时，只需登录同一账号，所有数据即可完整恢复，不会丢失任何记录。',
  },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '有漫画推荐、问题反馈或合作意向？我们随时聆听你的声音',
  intro: '无论是想推荐优秀的漫画作品、反馈阅读体验中的问题，还是洽谈内容合作与商务事宜，都欢迎通过以下方式与我们取得联系。',
  formId: 'd9k3oh8hpes2mi34sfqg',
  submitAddr: 'https://readdy.ai/api/form/d9k3oh8hpes2mi34sfqg',
  email: 'contact@sakuramanga.com',
};

export const commentItems = [
  {
    name: '漫画迷小林子',
    avatar: '',
    rating: 5,
    date: '2026年7月25日',
    content: '用了樱花漫画快两年了，下拉式阅读真的回不去了！现在看其他需要翻页的漫画网站都觉得好难受。推荐的书单质量也很高，发现了好几部冷门神作，感谢编辑团队！',
    likes: 328,
  },
  {
    name: '追更狂魔阿星',
    avatar: '',
    rating: 5,
    date: '2026年7月23日',
    content: '更新速度真的快，基本能做到同步更新。书架分类功能很实用，我把热血、恋爱、搞笑分开放，管理起来特别方便。无广告这一点必须点赞，阅读体验干净纯粹。',
    likes: 256,
  },
  {
    name: '夜半读书人',
    avatar: '',
    rating: 4,
    date: '2026年7月20日',
    content: 'APP的夜间模式做得不错，深夜追更眼睛不会太累。希望以后能加入更多国产原创漫画，支持国产！另外期待社区功能上线，想和同好们一起讨论剧情哈哈。',
    likes: 189,
  },
];

export const topicTags = [
  { name: '热血漫画', heat: '超热', count: '12.8万' },
  { name: '恋爱漫画', heat: '热门', count: '10.5万' },
  { name: '奇幻异世界', heat: '超热', count: '9.8万' },
  { name: '悬疑推理', heat: '热门', count: '7.2万' },
  { name: '搞笑日常', heat: '热门', count: '6.5万' },
  { name: '古风漫画', heat: '上升', count: '5.3万' },
  { name: '都市职场', heat: '热门', count: '4.8万' },
  { name: '科幻未来', heat: '上升', count: '4.2万' },
  { name: '完结漫画', heat: '超热', count: '8.6万' },
];

export const rankingItems = [
  {
    rank: 1,
    title: '星海征途',
    category: '科幻冒险',
    heat: '本周热度 98.6',
    trend: 'up',
    desc: '星际冒险史诗，画风精美剧情紧凑',
  },
  {
    rank: 2,
    title: '逆天战神',
    category: '热血战斗',
    heat: '本周热度 96.2',
    trend: 'up',
    desc: '超燃战斗场面，主角逆袭爽感拉满',
  },
  {
    rank: 3,
    title: '长安幻夜',
    category: '古风奇幻',
    heat: '本周热度 93.5',
    trend: 'up',
    desc: '盛唐背景奇幻故事，画风唯美动人',
  },
  {
    rank: 4,
    title: '甜蜜契约',
    category: '恋爱甜宠',
    heat: '本周热度 90.8',
    trend: 'stable',
    desc: '高甜恋爱漫画，完结可放心入坑',
  },
  {
    rank: 5,
    title: '末日生存指南',
    category: '悬疑生存',
    heat: '本周热度 88.3',
    trend: 'up',
    desc: '末日题材黑马，剧情张力持续走高',
  },
];

export const footerInfo = {
  name: '樱花漫画',
  desc: '樱花漫画是国内领先的免费漫画在线阅读平台，提供海量漫画全集下拉式阅读、每日追更、编辑精选推荐等服务。好看的漫画推荐尽在樱花漫画。',
  sections: {
    explore: {
      title: '探索',
      links: [
        { label: '专题合集', href: '#index' },
        { label: '焦点推荐', href: '#carousel' },
        { label: '热门榜单', href: '#ranking' },
        { label: '话题标签', href: '#topics' },
      ],
    },
    support: {
      title: '支持',
      links: [
        { label: '常见问答', href: '#faq' },
        { label: '联系我们', href: '#contact' },
        { label: '关于我们', href: '#about' },
        { label: '更新动态', href: '#updates' },
      ],
    },
  },
};